import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { AdminUser, AdminUserUpgrade } from 'src/types/shared/AdminUser';
import { ChallengeApplicationResponse } from 'src/types/shared/Challenge';

export const upgradeAdminUserRequest = createAction('upgradeAdminUserRequest');
export const upgradeAdminUserSuccess = createAction<AdminUser>('upgradeAdminUserSuccess');
export const upgradeAdminUserFailure = createAction('upgradeAdminUserFailure');

export const upgradeAdminUser = (id: number, postBody: AdminUserUpgrade) => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(upgradeAdminUserRequest());
    try {
        const { data }: UpdateAdminResponse = await api.patch(
            `admin/admins/${id}/upgrade`,
            postBody,
        );

        dispatch(upgradeAdminUserSuccess(data.user));
    } catch (e) {
        handleApiErrors(dispatch, upgradeAdminUserFailure, e);
    }
};

interface AdminUserResponse {
    user: AdminUser;
    challengeApplications: ChallengeApplicationResponse[];
}
interface UpdateAdminResponse {
    data: AdminUserResponse;
}
